// extracted by mini-css-extract-plugin
export default {"status":"DevelopScope_status__xN-1B","collapse":"DevelopScope_collapse__TMgy7","filter":"DevelopScope_filter__bb70R"};